import { lazyPage, type ModulePlugin } from "@keel/core";

const layout = () => import("./Layout");
const Bins = lazyPage(layout, "Bins");
const counts = () => import("./Counts");
const Counts = lazyPage(counts, "Counts");
const CountSheet = lazyPage(counts, "CountSheet");
const Putaway = lazyPage(() => import("./Putaway"), "Putaway");

/**
 * Warehouse (optional module): running a building — zones and bins, shelving what arrived, and
 * counting what is on it. Stock itself stays with inventory; this is the work around it.
 */
const plugin: ModulePlugin = {
  key: "warehouse",
  records: { StockCount: "/stock-counts/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Warehouse",
      items: [
        { to: "/putaway", label: "Putaway", icon: "boxes", perm: "warehouse.operations.read" },
        { to: "/stock-counts", label: "Stock counts", icon: "check", perm: "warehouse.operations.read" },
        {
          to: "/warehouse-layout",
          label: "Zones & bins",
          icon: "warehouse",
          perm: "warehouse.operations.read",
        },
      ],
    },
  ],
  routes: [
    { path: "/putaway", element: <Putaway /> },
    { path: "/stock-counts", element: <Counts /> },
    { path: "/stock-counts/:id", element: <CountSheet /> },
    { path: "/warehouse-layout", element: <Bins /> },
  ],
  // A stock-count adjustment in the ledger or the movement list links back to its sheet.
  sources: { stock_count: "/stock-counts/" },
  commands: [
    ["Putaway", "/putaway", "boxes", "warehouse.operations.read"],
    ["Stock counts", "/stock-counts", "check", "warehouse.operations.read"],
    ["New stock count", "/stock-counts?new=1", "plus", "warehouse.operations.write"],
    ["Zones & bins", "/warehouse-layout", "warehouse", "warehouse.operations.read"],
  ],
  newMenu: [
    {
      label: "Stock count",
      to: "/stock-counts?new=1",
      perm: "warehouse.operations.write",
      section: "Warehouse",
    },
  ],
};
export default plugin;
